import React from 'react';
import type { Length } from '../common';
import {
  AccountPage,
  AccountsPage,
  ApplicationsPage,
  ConfirmResetPasswordPage,
  CoursePage,
  CoursesPage,
  LoginPage,
  LogoutPage,
  MerchantUsefulLinksPage,
  MerchantUsersPage,
  NotFoundPage,
  PAPage,
  PlatformUsersPage,
  Reporting,
  ResetPasswordPage,
  SMSVerificationPage,
  SNPLPage
} from '../components/pages';

import {
  AccountCourses,
  AccountContacts,
  AccountOverview,
  AccountProducts,
  LoginTemplate,
  SidebarTemplate
} from '../components';

import { allPaths } from './Paths';
import { type RouteObject, Navigate } from 'react-router-dom';

// @todo Add type for routes following structure change
// type Routes<T> = { [K in keyof T]: { path: T[K]; element: Element } };
// type AllRoutes = Routes<typeof allPathUrls>;

/**
 * Added a type for the routes to ensure there's no accidental typos or missed routes
 * unfortunately it doesn't seem to work when the path is imported for whatever reason
 * leaving it hardcoded for now
 */
const routes: ReadonlyArray<RouteObject> = [
  {
    path: '/',
    element: <Navigate to={allPaths.LOGIN.path} replace />
  },

  {
    path: allPaths.LOGOUT.path,
    element: <LogoutPage />
  },
  {
    // Error page,
    path: '*',
    element: <NotFoundPage />
  },
  /* --- login template */
  {
    element: <LoginTemplate />,
    children: [
      {
        path: allPaths.LOGIN.path,
        element: <LoginPage />
      },
      {
        path: allPaths.SMS_VERIFICATION.path,
        element: <SMSVerificationPage />
      },
      {
        path: allPaths.RESET_PASSWORD.path,
        element: <ResetPasswordPage />
      },
      {
        path: allPaths.CONFIRM_RESET_PASSWORD.path,
        element: <ConfirmResetPasswordPage />
      }
    ]
  },
  /* --- sidebar template */
  {
    element: <SidebarTemplate />,
    children: [
      {
        path: allPaths.APPLICATIONS.path,
        element: <ApplicationsPage />
      },
      {
        path: allPaths.SNPL.path,
        element: <SNPLPage />
      },
      {
        path: allPaths.PAYMENT_ASSIST.path,
        element: <PAPage />
      },
      {
        path: allPaths.COURSES.path,
        element: <CoursesPage />
      },
      {
        path: allPaths.REPORTING.path,
        element: <Reporting />
      },
      {
        path: '/account/:merchantId',
        element: <AccountPage />,
        children: [
          {
            index: true,
            element: <AccountOverview />
          },
          {
            path: 'products',
            element: <AccountProducts />
          },
          {
            path: 'contacts',
            element: <AccountContacts />
          },
          {
            path: 'courses',
            element: <AccountCourses />
          }
        ]
      },
      {
        path: '/account/:merchantId/course/:courseId',
        element: <CoursePage />
      },
      {
        path: allPaths.ACCOUNTS.path,
        element: <AccountsPage />
      },
      // admin routes
      {
        path: '/users',
        element: <MerchantUsersPage />
      },
      {
        path: allPaths.USEFUL_LINKS.path,
        element: <MerchantUsefulLinksPage />
      },
      {
        path: '/platform/users',
        element: <PlatformUsersPage />
      }
    ]
  }
];

type AllRoutesLength = Length<typeof routes>;
// const foo = AllPathsLength

// Expect<Equal<AllPathsLength<typeof
// Todo look at doing this with a
// if (routes.length !== allPathNames.length) {
//   Logger.error({
//     source: 'Routes.tsx',
//     message: `Incorrect number of routes expected: ${allPathNames.length}, received: ${routes.length}`
//   });
// } else {
//   console.log('ROUTES>>>>', routes);
// }

export { routes };
